import { V2_ORGS_ROLES_PATH } from '@/v2/utils/routes'

export const CLASSIC_ASSOCIATED_PARTIES_BASE_PATH = '/associated-parties'
export const V2_ORGS_ROLES_BASE_PATH = V2_ORGS_ROLES_PATH

export function getAssociatedPartiesBasePath(pathname: string): string {
  if (pathname === '/v2' || pathname.startsWith('/v2/')) {
    return V2_ORGS_ROLES_BASE_PATH
  }
  return CLASSIC_ASSOCIATED_PARTIES_BASE_PATH
}

export function getAssociatedPartiesListPath(pathname: string): string {
  return getAssociatedPartiesBasePath(pathname)
}

export function getAssociatedPartyDetailPath(
  pathname: string,
  associatedPartyId: string
): string {
  return `${getAssociatedPartiesBasePath(pathname)}/${associatedPartyId}`
}

export function isV2AssociatedPartiesShell(pathname: string): boolean {
  return pathname.startsWith(V2_ORGS_ROLES_BASE_PATH)
}
